import { FORM_ERROR } from 'final-form';
import { has, set } from 'lodash-es';
import { setLocale, ValidationError } from 'yup';
import type { ValidationErrors } from 'final-form';
import type { ObjectSchema } from 'yup';
import type { ObjectShape } from 'yup/lib/object';

setLocale({
  mixed: {
    required: 'Поле обязательно к заполнению',
  },
});

export const createValidator =
  <T extends ObjectSchema<ObjectShape>>(validator: T) =>
  (values: unknown): ValidationErrors | Promise<ValidationErrors> | undefined => {
    try {
      validator.validateSync(values, {
        abortEarly: false,
      });
      return undefined;
    } catch (err) {
      if (!(err instanceof ValidationError)) {
        console.error(err);
        return undefined;
      }

      return err.inner.reduce((errors, { path, message }) => {
        const fieldPath = path ?? FORM_ERROR;
        if (has(errors, fieldPath)) {
          return errors;
        }

        return set(errors, fieldPath, message);
      }, {});
    }
  };
